import constants from 'Helpers/constants';
import store from '../../store';

export default {
    namespaced: true,
    state: {
        betTypeDictionary: [],
        languageDictionary: [
            { id: 'en', key: 'english' },
            { id: 'pt', key: 'portuguese' },
        ],
        tradingTypeDictionary: [
            { id: 1, key: 'bot' },
            { id: 2, key: 'order' },
        ],
        botDictionary: [],
        botBetTypeDictionary: [],
        betStatusDictionary: [],
        betSelectionDictionary: [],
        betRepetitionDictionary: [],
        betFailPlainErrorDictionary: [],
        betOrderCloseReasonDictionary: [
            {
                id: constants.ORDER_CLOSE_REASON_NORMALLY,
                key: 'closeReasonNormally',
            },
            {
                id: constants.ORDER_CLOSE_REASON_SCORE_CHANGED,
                key: 'closeReasonScoreChanged',
            },
            {
                id: constants.ORDER_CLOSE_REASON_TIMED_OUT,
                key: 'closeReasonTimedOut',
            },
            {
                id: constants.ORDER_CLOSE_REASON_INSUFFICIENT_CREDIT,
                key: 'closeReasonInsufficientCredit',
            },
            {
                id: constants.ORDER_CLOSE_REASON_GAME_FINISHED,
                key: 'closeReasonGameFinished',
            },
            {
                id: constants.ORDER_CLOSE_REASON_MANUALLY_CLOSED,
                key: 'closeReasonManuallyClosed',
            },
            {
                id: constants.ORDER_CLOSE_REASON_GAME_STARTED,
                key: 'closeReasonGameStarted',
            },
            {
                id: constants.ORDER_CLOSE_REASON_REJECTED_BET,
                key: 'closeReasonGameRejectedBet',
            },
            {
                id: constants.ORDER_CLOSE_REASON_ACCOUNT_BLOCKED,
                key: 'closeReasonGameAccountBlocked',
            },
        ],
        betOrderStatusDictionary: [
            { id: constants.ORDER_STATUS_OPEN_ID, key: 'open' },
            { id: constants.ORDER_STATUS_CLOSING_ID, key: 'closing' },
            { id: constants.ORDER_STATUS_CLOSED_ID, key: 'closed' },
        ],
        eventSituationDictionary: [],
        eventRedCardDictionary: [],
        // feedLeagueDictionary: [],
        dballMarketDictionary: [
            { id: constants.DBALL_MARKET_TODAY, key: 'todayMarket' },
            { id: constants.DBALL_MARKET_EARLY, key: 'earlyMarket' },
        ],
        defaultOddsTypeDictionary: [
            { id: constants.DEFAULT_ODDS_TYPE_BEST, key: 'bestOdds' },
            { id: constants.DEFAULT_ODDS_TYPE_MEDIAN, key: 'medianOdds' },
            { id: constants.DEFAULT_ODDS_TYPE_LOWEST, key: 'lowestOdds' },
        ],
        lineDictionary: [
            // { id: constants.LINE_ALL, key: 'allLines' },
            { id: constants.LINE_MAIN, key: 'mainLine' },
            { id: constants.LINE_TWO, key: 'twoLines' },
            { id: constants.LINE_THREE, key: 'threeLines' },
            { id: constants.LINE_FOUR, key: 'fourLines' },
            { id: constants.LINE_FIVE, key: 'fiveLines' },
        ],
        marketTypeDictionary: [
            // { id: constants.LINE_ALL, key: 'allLines' },
            { id: constants.BET_MARKET_TYPE_1X2, key: '1X2' },
            { id: constants.BET_MARKET_TYPE_HANDICAP, key: 'handicap' },
            { id: constants.BET_MARKET_TYPE_GOAL, key: 'goal' },
            { id: constants.BET_MARKET_TYPE_BTTS, key: 'BTTS' },
            { id: constants.BET_MARKET_TYPE_DC, key: 'doubleChance' },
            { id: constants.BET_MARKET_TYPE_CS, key: 'correctScore' },
        ],
        eventPeriodDictionary: [
            { id: constants.EVENT_PERIOD_FT, code: 'FT', key: 'periodFT' },
            { id: constants.EVENT_PERIOD_1H, code: '1H', key: 'period1H' },
        ],
        scoreSumConditionDictionary: [
            { id: '=', key: 'equalTo' },
            { id: '>', key: 'greaterThan' },
            { id: '<', key: 'lessThan' },
        ],
        genderDictionary: [
            { id: constants.MEN, key: 'men' },
            { id: constants.WOMEN, key: 'women' },
        ],
        teamGenderDictionary: [
            { id: constants.TEAM_MEN, key: 'men' },
            { id: constants.TEAM_WOMEN, key: 'women' },
        ],
        teamAgeDictionary: [
            { id: constants.TEAM_YOUTH, key: 'youth' },
            { id: constants.TEAM_SENIOR, key: 'senior' },
        ],
        statusDictionary: [
            { key: 'active', value: 'active' },
            { key: 'inactive', value: 'inactive' },
        ],
        leagueGroupDictionary: [],
        ageDictionary: [],
        categoryDictionary: [],
        teamTypeDictionary: [],
        limitsDictionary: [],
        botFavoriteSideDictionary: [],
        siteAllDictionary: [],
        siteDictionary: [],
        orderSiteDictionary: [],
        countryDictionary: [],
        allowedCountryDictionary: [],
        customLeagueDictionary: [],
        proxyByIpDictionary: [],
        currencyAllDictionary: [],
        teamSelectionDictionary: [],
        timeZoneDictionary: [],
        currencyDictionary: [],
        timeoutLiveDictionary: [
            { id: 5, name: '5 sec' },
            { id: 10, name: '10 sec' },
            { id: 15, name: '15 sec' },
            { id: 30, name: '30 sec' },
            { id: 60, name: '1 min' },
            { id: 120, name: '2 mins' },
            { id: 300, name: '5 mins' },
            { id: 600, name: '10 mins' },
            { id: 900, name: '15 mins' },
            { id: 1200, name: '20 mins' },
            { id: 1800, name: '30 mins' },
            { id: 2700, name: '45 mins' },
            { id: 3600, name: '60 mins' },
            { id: 4500, name: '75 mins' },
        ],
        timeoutDballDictionary: [
            { id: 5, name: '5 sec' },
            { id: 10, name: '10 sec' },
            { id: 15, name: '15 sec' },
            { id: 30, name: '30 sec' },
            { id: 60, name: '1 min' },
            { id: 120, name: '2 mins' },
            { id: 300, name: '5 mins' },
            { id: 600, name: '10 mins' },
            { id: 900, name: '15 mins' },
            { id: 1200, name: '20 mins' },
            { id: 1800, name: '30 mins' },
            { id: 2700, name: '45 mins' },
            { id: 3600, name: '1 hr' },
            { id: 7200, name: '2 hrs' },
            { id: 14400, name: '4 hrs' },
            { id: 21600, name: '6 hrs' },
            { id: 43200, name: '12 hrs' },
            { id: 86400, name: '24 hrs' },
            { id: 172800, name: '48 hrs' },
            { id: 259200, name: '72 hrs' },
            { id: null, key: 'kickOff' },
        ],
        timeDictionary: [
            { id: 5, key: '5s' },
            { id: 15, key: '15s' },
            { id: 30, key: '30s' },
            { id: 60, key: '1min' },
            { id: 300, key: '5min' },
            { id: 0, key: 'off' },
        ],
        marginPercDictionary: [
            { id: 102, name: '102%' },
            { id: 103, name: '103%' },
            { id: 104, name: '104%' },
            { id: 105, name: '105%' },
            { id: 106, name: '106%' },
            { id: 107, name: '107%' },
            { id: 108, name: '108%' },
            { id: 109, name: '109%' },
            { id: 110, name: '110%' },
            { id: 120, name: '120%' },
        ],
        possessionDictionary: [
            { id: 50, name: '50%' },
            { id: 51, name: '51%' },
            { id: 52, name: '52%' },
            { id: 53, name: '53%' },
            { id: 54, name: '54%' },
            { id: 55, name: '55%' },
            { id: 56, name: '56%' },
            { id: 57, name: '57%' },
            { id: 58, name: '58%' },
            { id: 59, name: '59%' },
            { id: 60, name: '60%' },
            { id: 61, name: '61%' },
            { id: 62, name: '62%' },
            { id: 63, name: '63%' },
            { id: 64, name: '64%' },
            { id: 65, name: '65%' },
            { id: 66, name: '66%' },
            { id: 67, name: '67%' },
            { id: 68, name: '68%' },
            { id: 69, name: '69%' },
            { id: 70, name: '70%' },
            { id: 71, name: '71%' },
            { id: 72, name: '72%' },
            { id: 73, name: '73%' },
            { id: 74, name: '74%' },
            { id: 75, name: '75%' },
            { id: 76, name: '76%' },
            { id: 77, name: '77%' },
            { id: 78, name: '78%' },
            { id: 79, name: '79%' },
            { id: 80, name: '80%' },
            { id: 81, name: '81%' },
            { id: 82, name: '82%' },
            { id: 83, name: '83%' },
            { id: 84, name: '84%' },
            { id: 85, name: '85%' },
            { id: 86, name: '86%' },
            { id: 87, name: '87%' },
            { id: 88, name: '88%' },
            { id: 89, name: '89%' },
            { id: 90, name: '90%' },
            { id: 91, name: '91%' },
            { id: 92, name: '92%' },
            { id: 93, name: '93%' },
            { id: 94, name: '94%' },
            { id: 95, name: '95%' },
            { id: 96, name: '96%' },
            { id: 97, name: '97%' },
            { id: 98, name: '98%' },
            { id: 99, name: '99%' },
        ],
        minuteDictionary: [
            { id: '1', name: '1' },
            { id: '2', name: '2' },
            { id: '3', name: '3' },
            { id: '4', name: '4' },
            { id: '5', name: '5' },
            { id: '6', name: '6' },
            { id: '7', name: '7' },
            { id: '8', name: '8' },
            { id: '9', name: '9' },
            { id: '10', name: '10' },
            { id: '11', name: '11' },
            { id: '12', name: '12' },
            { id: '13', name: '13' },
            { id: '14', name: '14' },
            { id: '15', name: '15' },
            { id: '16', name: '16' },
            { id: '17', name: '17' },
            { id: '18', name: '18' },
            { id: '19', name: '19' },
            { id: '20', name: '20' },
            { id: '21', name: '21' },
            { id: '22', name: '22' },
            { id: '23', name: '23' },
            { id: '24', name: '24' },
            { id: '25', name: '25' },
            { id: '26', name: '26' },
            { id: '27', name: '27' },
            { id: '28', name: '28' },
            { id: '29', name: '29' },
            { id: '30', name: '30' },
            { id: '31', name: '31' },
            { id: '32', name: '32' },
            { id: '33', name: '33' },
            { id: '34', name: '34' },
            { id: '35', name: '35' },
            { id: '36', name: '36' },
            { id: '37', name: '37' },
            { id: '38', name: '38' },
            { id: '39', name: '39' },
            { id: '40', name: '40' },
            { id: '41', name: '41' },
            { id: '42', name: '42' },
            { id: '43', name: '43' },
            { id: '44', name: '44' },
            { id: '45', name: '45' },
            { id: '45+1', name: '45+1' },
            { id: '45+2', name: '45+2' },
            { id: '45+3', name: '45+3' },
            { id: 'HT', name: 'HT' },
            { id: '46', name: '46' },
            { id: '47', name: '47' },
            { id: '48', name: '48' },
            { id: '49', name: '49' },
            { id: '50', name: '50' },
            { id: '51', name: '51' },
            { id: '52', name: '52' },
            { id: '53', name: '53' },
            { id: '54', name: '54' },
            { id: '55', name: '55' },
            { id: '56', name: '56' },
            { id: '57', name: '57' },
            { id: '58', name: '58' },
            { id: '59', name: '59' },
            { id: '60', name: '60' },
            { id: '61', name: '61' },
            { id: '62', name: '62' },
            { id: '63', name: '63' },
            { id: '64', name: '64' },
            { id: '65', name: '65' },
            { id: '66', name: '66' },
            { id: '67', name: '67' },
            { id: '68', name: '68' },
            { id: '69', name: '69' },
            { id: '70', name: '70' },
            { id: '71', name: '71' },
            { id: '72', name: '72' },
            { id: '73', name: '73' },
            { id: '74', name: '74' },
            { id: '75', name: '75' },
            { id: '76', name: '76' },
            { id: '77', name: '77' },
            { id: '78', name: '78' },
            { id: '79', name: '79' },
            { id: '80', name: '80' },
            { id: '81', name: '81' },
            { id: '82', name: '82' },
            { id: '83', name: '83' },
            { id: '84', name: '84' },
            { id: '85', name: '85' },
            { id: '86', name: '86' },
            { id: '87', name: '87' },
            { id: '88', name: '88' },
            { id: '89', name: '89' },
            { id: '90', name: '90' },
            { id: '91', name: '91' },
            { id: '92', name: '92' },
            { id: '93', name: '93' },
            { id: '94', name: '94' },
            { id: '95', name: '95' },
            { id: 'FT', name: 'FT' },
        ],
    },
    mutations: {
        setBetType(state, betType) {
            state.betTypeDictionary = betType;
        },

        setBetFailPlainError(state, betFailPlainError) {
            state.betFailPlainErrorDictionary = betFailPlainError;
        },

        setBotBetType(state, botBetType) {
            state.botBetTypeDictionary = botBetType;
        },

        setBetStatus(state, betStatus) {
            state.betStatusDictionary = betStatus;
        },

        setBetSelection(state, betSelection) {
            state.betSelectionDictionary = betSelection;
        },

        setBetRepetition(state, betRepetition) {
            state.betRepetitionDictionary = betRepetition;
        },

        setEventSituation(state, eventSituation) {
            state.eventSituationDictionary = eventSituation;
        },

        // setFeedLeague(state, feedLeague) {
        //     state.feedLeagueDictionary = feedLeague;
        // },

        setBetOrderCloseReason(state, orderCloseReason) {
            state.betOrderCloseReasonDictionary = orderCloseReason;
        },

        setEventRedCard(state, eventRedCard) {
            state.eventRedCardDictionary = eventRedCard;
        },

        setProxyByIp(state, proxyByIp) {
            state.proxyByIpDictionary = proxyByIp;
        },

        setCurrency(state, currency) {
            state.currencyDictionary = currency;
        },

        setCurrencyAll(state, currencyAll) {
            state.currencyAllDictionary = currencyAll;
        },

        setLeagueGroup(state, leagueGroup) {
            state.leagueGroupDictionary = leagueGroup;
        },

        setCustomLeagueAgeCategory(state, age) {
            state.ageDictionary = age;
        },

        setCustomLeagueCategory(state, category) {
            state.categoryDictionary = category;
        },

        setCustomTeamType(state, teamType) {
            state.teamTypeDictionary = teamType;
        },

        setCustomLeagueLimitsCategory(state, limits) {
            state.limitsDictionary = limits;
        },

        setBotFavoriteSide(state, botFavoriteSide) {
            for (let key in botFavoriteSide) {
                botFavoriteSide[key]['name'] = this.$i18n.t('dictionaries.' + botFavoriteSide[key]['name']);
            }
            state.botFavoriteSideDictionary = botFavoriteSide;
        },

        setBot(state, bot) {
            state.botDictionary = bot;
        },

        setSiteAll(state, siteAll) {
            state.siteAllDictionary = siteAll;
        },

        setSite(state, site) {
            state.siteDictionary = site;
        },

        setOrderSite(state, site) {
            state.orderSiteDictionary = site;
        },

        setCountry(state, country) {
            state.countryDictionary = country;
        },

        setAllowedCountry(state, country) {
            state.allowedCountryDictionary = country;
        },

        setCustomLeague(state, customLeague) {
            state.customLeagueDictionary = customLeague;
        },

        setTeamSelection(state, possessionTeamSelection) {
            state.teamSelectionDictionary = possessionTeamSelection;
        },

        setTimeZone(state, timeZone) {
            state.timeZoneDictionary = timeZone;
        },
    },
    getters: {
        getAgeDictionary(state) {
            return state.ageDictionary;
        },

        getBetTypeDictionary(state) {
            return state.betTypeDictionary;
        },

        getTradingTypeDictionary(state) {
            let tradingType = state.tradingTypeDictionary;

            for (let key in tradingType) {
                tradingType[key]['name'] = store.$i18n.t('dictionaries.' + tradingType[key]['key']);
            }

            state.tradingTypeDictionary = tradingType;
            return state.tradingTypeDictionary;
        },

        getBetFailPlainErrorDictionary(state) {
            return state.betFailPlainErrorDictionary;
        },

        getBotBetTypeDictionary(state) {
            return state.botBetTypeDictionary;
        },

        getBotDictionary(state) {
            return state.botDictionary;
        },

        getBetStatusDictionary(state) {
            return state.betStatusDictionary;
        },

        getBetSelectionDictionary(state) {
            return state.betSelectionDictionary;
        },

        getBetTypeRepetitionDictionary(state) {
            return state.betRepetitionDictionary;
        },

        // getFeedLeagueDictionary(state) {
        //     return state.feedLeagueDictionary;
        // },

        getBetOrderCloseReasonDictionary(state) {
            let status = state.betOrderCloseReasonDictionary;

            for (let key in status) {
                status[key]['name'] = store.$i18n.t('dictionaries.' + status[key]['key']);
            }

            state.betOrderCloseReasonDictionary = status;
            return state.betOrderCloseReasonDictionary;
        },

        getDballMarketDictionary(state) {
            let dballMarket = state.dballMarketDictionary;

            for (let key in dballMarket) {
                dballMarket[key]['name'] = store.$i18n.t('dictionaries.' + dballMarket[key]['key']);
            }

            state.dballMarketDictionary = dballMarket;
            return state.dballMarketDictionary;
        },

        getDefaultOddsTypeDictionary(state) {
            let defaultOddsType = state.defaultOddsTypeDictionary;

            for (let key in defaultOddsType) {
                defaultOddsType[key]['name'] = store.$i18n.t('dictionaries.' + defaultOddsType[key]['key']);
            }

            state.defaultOddsTypeDictionary = defaultOddsType;
            return state.defaultOddsTypeDictionary;
        },

        getLineDictionary(state) {
            let line = state.lineDictionary;

            for (let key in line) {
                line[key]['name'] = store.$i18n.t('dictionaries.' + line[key]['key']);
            }

            state.lineDictionary = line;
            return state.lineDictionary;
        },

        getMarketTypeDictionary(state) {
            let line = state.marketTypeDictionary;

            for (let key in line) {
                line[key]['name'] = store.$i18n.t('dictionaries.' + line[key]['key']);
            }

            state.marketTypeDictionary = line;
            return state.marketTypeDictionary;
        },

        getEventPeriodDictionary(state) {
            let period = state.eventPeriodDictionary;

            for (let key in period) {
                period[key]['name'] = store.$i18n.t('dictionaries.' + period[key]['key']);
            }

            state.eventPeriodDictionary = period;
            return state.eventPeriodDictionary;
        },

        getEventSituationDictionary(state) {
            return state.eventSituationDictionary;
        },

        getScoreSumConditionDictionary(state) {
            let scoreSumCondition = state.scoreSumConditionDictionary;

            for (let key in scoreSumCondition) {
                scoreSumCondition[key]['name'] = store.$i18n.t('dictionaries.' + scoreSumCondition[key]['key']);
            }

            state.scoreSumConditionDictionary = scoreSumCondition;
            return state.scoreSumConditionDictionary;
        },

        getEventRedCardDictionary(state) {
            return state.eventRedCardDictionary;
        },

        getProxyByIpDictionary(state) {
            return state.proxyByIpDictionary;
        },

        getCurrencyDictionary(state) {
            return state.currencyDictionary;
        },

        getCurrencyAllDictionary(state) {
            return state.currencyAllDictionary;
        },

        getLeagueGroupDictionary(state) {
            return state.leagueGroupDictionary;
        },

        getGenderDictionary(state) {
            let gender = state.genderDictionary;

            for (let key in gender) {
                gender[key]['name'] = store.$i18n.t('dictionaries.' + gender[key]['key']);
            }

            state.genderDictionary = gender;
            return state.genderDictionary;
        },

        getTeamGenderDictionary(state) {
            let gender = state.teamGenderDictionary;

            for (let key in gender) {
                gender[key]['name'] = store.$i18n.t('dictionaries.' + gender[key]['key']);
            }

            state.teamGenderDictionary = gender;
            return state.teamGenderDictionary;
        },

        getTeamAgeDictionary(state) {
            let gender = state.teamAgeDictionary;

            for (let key in gender) {
                gender[key]['name'] = store.$i18n.t('dictionaries.' + gender[key]['key']);
            }

            state.teamAgeDictionary = gender;
            return state.teamAgeDictionary;
        },

        getStatusDictionary(state) {
            let status = state.statusDictionary;

            for (let key in status) {
                status[key]['text'] = store.$i18n.t('dictionaries.' + status[key]['key']);
            }

            state.statusDictionary = status;
            return state.statusDictionary;
        },

        getBetOrderStatusDictionary(state) {
            let status = state.betOrderStatusDictionary;

            for (let key in status) {
                status[key]['name'] = store.$i18n.t('dictionaries.' + status[key]['key']);
            }

            state.betOrderStatusDictionary = status;
            return state.betOrderStatusDictionary;
        },

        getCategoryDictionary(state) {
            return state.categoryDictionary;
        },

        getTeamTypeDictionary(state) {
            return state.teamTypeDictionary;
        },

        getLimitsDictionary(state) {
            return state.limitsDictionary;
        },

        getBotFavoriteSideDictionary(state) {
            return state.botFavoriteSideDictionary;
        },

        getSiteAllDictionary(state) {
            return state.siteAllDictionary;
        },

        getSiteDictionary(state) {
            return state.siteDictionary;
        },

        getOrderSiteDictionary(state) {
            return state.orderSiteDictionary;
        },

        getCountryDictionary(state) {
            return state.countryDictionary;
        },

        getAllowedCountryDictionary(state) {
            return state.allowedCountryDictionary;
        },

        getCustomLeagueDictionary(state) {
            return state.customLeagueDictionary;
        },

        getTeamSelectionDictionary(state) {
            return state.teamSelectionDictionary;
        },

        getTimeDictionary(state) {
            let timeout = state.timeDictionary;

            for (let key in timeout) {
                if (timeout[key]['key']) {
                    timeout[key]['name'] = store.$i18n.t('dictionaries.' + timeout[key]['key']);
                }
            }

            state.timeDictionary = timeout;
            return state.timeDictionary;
        },

        getTimeoutLiveDictionary(state) {
            return state.timeoutLiveDictionary;
        },

        getTimeoutDballDictionary(state) {
            let timeout = state.timeoutDballDictionary;

            for (let key in timeout) {
                if (timeout[key]['id'] === null) {
                    if (timeout[key]['key']) {
                        timeout[key]['name'] = store.$i18n.t('panel.' + timeout[key]['key']);
                    }
                }
            }

            state.timeoutDballDictionary = timeout;
            return state.timeoutDballDictionary;
        },

        getMarginPercDictionary(state) {
            return state.marginPercDictionary;
        },

        getPossessionDictionary(state) {
            return state.possessionDictionary;
        },

        getTimeZone(state) {
            return state.timeZoneDictionary;
        },

        getLanguage(state) {
            let language = state.languageDictionary;

            for (let key in language) {
                language[key]['name'] = store.$i18n.t('dictionaries.' + language[key]['key']);
            }

            state.languageDictionary = language;
            return state.languageDictionary;
        },

        getMinuteDictionary(state) {
            return state.minuteDictionary;
        },
    },

    actions: {
        setDictionaries(context, dictionaries) {
            for (let dictionary in dictionaries) {
                context.commit('set' + dictionary, dictionaries[dictionary]);
            }
        },
    },
};
